module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_2.6cede1bc.jpg";